<template>
  <div
    class="fixed bottom-0 left-0 right-0 z-40 flex flex-col md:flex-row md:items-center justify-between gap-4 p-4 border-t-2 border-slate-200 shadow-lg bg-white"
  >
    <div class="flex flex-wrap items-center gap-x-8 gap-y-2 text-[#64648B] text-sm">
      <div>
        <p class="text-xs uppercase tracking-wide text-slate-500">Monthly cost</p>
        <p class="text-lg font-semibold text-slate-800">
          <span v-currency="monthlyRecurringCost" :key="monthlyRecurringCost">
            {{ monthlyRecurringCost }}
          </span>
        </p>
      </div>
      <div>
        <p class="text-xs uppercase tracking-wide text-slate-500">Total 12 months</p>
        <p class="text-lg font-semibold text-slate-800">
          <span v-currency="yearlyCost" :key="yearlyCost">{{ yearlyCost }}</span>
        </p>
      </div>
      <div v-if="itemCount > 0">
        <p class="text-xs uppercase tracking-wide text-slate-500">Configured</p>
        <p class="text-lg font-semibold text-slate-800">
          {{ itemCount }} {{ itemCount === 1 ? "service" : "services" }}
        </p>
      </div>
    </div>

    <div class="flex items-center gap-3">
      <div v-if="addservice" :class="{ disabled: !addEnabled }">
        <PrimaryButton :text="'Add to estimate'" @click="handleAddService" />
      </div>

      <div v-if="summary">
        <PrimaryButton :text="'View summary'" @click="handleViewSummary" />
      </div>
    </div>

    <!-- Add Service Confirmation Modal -->
    <div v-if="showAddModal" class="modal" @click.self="showAddModal = false">
      <div class="modal-content">
        <h1 class="text-lg font-bold py-2">Add to estimate</h1>
        <p class="text-sm text-slate-600">
          Add {{ itemCount || 1 }}
          {{ (itemCount || 1) === 1 ? "configured service" : "configured services" }} to your
          estimate?
        </p>
        <div class="flex gap-3 justify-end mt-4">
          <button
            class="px-3 py-2 text-sm border border-slate-300 rounded hover:bg-slate-50"
            @click="showAddModal = false"
          >
            Cancel
          </button>
          <PrimaryButton text="Add" @click="confirmAddService" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "./PrimaryButton.vue";

export default {
  components: {
    PrimaryButton,
  },
  props: {
    monthlyRecurringCost: { type: Number, default: 0 },
    itemCount: { type: Number, default: 0 },
    addservice: { type: Boolean, default: false },
    canAdd: { type: Boolean, default: false },
    summary: { type: Boolean, default: false },
  },
  emits: ["addservice"],
  data() {
    return {
      showAddModal: false,
    };
  },
  computed: {
    yearlyCost() {
      return this.monthlyRecurringCost * 12;
    },
    // On-request items cost nothing but are still worth adding, so the button
    // follows the configured-item count rather than the price.
    addEnabled() {
      return this.canAdd || this.monthlyRecurringCost > 0;
    },
  },
  methods: {
    handleAddService() {
      if (!this.addEnabled) return;
      this.showAddModal = true;
    },
    confirmAddService() {
      this.showAddModal = false;
      this.$emit("addservice");
    },
    handleViewSummary() {
      this.$router.push("/summary");
    },
  },
};
</script>

<style lang="postcss" scoped>
.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  width: 400px;
  max-width: 90%;
}
</style>
